import React from "react";
import { Warning } from "@phosphor-icons/react";

// P7 (product owner, 2026-11-02): the assessment says so when an answer had profanity.
// Shown from the evaluation's `profanity` flag; the words themselves are never stored.
export default function ProfanityNote({ text, testId }) {
  return (
    <div
      className="mt-4 flex gap-3 rounded-2xl border border-[color:var(--score-bad)]/30 bg-[color:var(--score-bad)]/10 px-5 py-4 text-sm leading-relaxed text-[color:var(--text-primary)]"
      role="note"
      data-testid={testId}
    >
      <Warning size={18} weight="duotone" className="mt-0.5 shrink-0 text-[color:var(--score-bad)]" />
      <span>{text}</span>
    </div>
  );
}
